import {MediaChange, MediaObserver} from '@angular/flex-layout';
import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class FuseMatchMedia
{
    activeMediaQuery: string;
    onMediaChange: EventEmitter<string> = new EventEmitter<string>();

    constructor(private observableMedia: MediaObserver )
    {
        this.activeMediaQuery = '';

        this.observableMedia.asObservable().subscribe((change) => {
            if ( this.activeMediaQuery !== change[0].mqAlias )
            {
                this.activeMediaQuery = change[0].mqAlias;
                this.onMediaChange.emit(change[0].mqAlias);
            }
        });
    }
}
